import {Component, AfterViewInit, ViewChild} from '@angular/core';
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';
import {MatLegacyButton as MatButton} from '@angular/material/legacy-button';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MatLegacyInput as MatInput} from '@angular/material/legacy-input';
import {MatSort} from '@angular/material/sort';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {SelectionModel} from '@angular/cdk/collections';
import {NewGroupComponent} from '../new-group/new-group.component';
import {ShareComponent} from '../../share/share.component';


import {IdexService} from '../../../idex.service';
import {Toast} from '../../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {merge, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {AppLoaderComponent} from '../../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../../shared/paginator/paginator.component';

@Component({
   selector: 'app-group',
   templateUrl: './group.component.html',
   styleUrls: ['./group.component.css']
})
export class GroupComponent implements AfterViewInit {
   isLoadingResults = true;
   isLoadingResultsShare = true;
   isRateLimitReached = false;
   isRateLimitReachedShare = false;
   showTabShare = false;
   resultsLength = 0;
   resultsLengthShare = 0;
   errorMessage: string;
   contactType: string;
   selectTabIndex;
   selectedRowIndex = -1;
   selectedRowIndexGroup = -1;
   selectedRowIndexGroupShare = -1;
   isAddGroup = true;
   clickActive: boolean;

   displayedColumnsGroup = ['select', 'no', 'group_name', 'active', 'menu'];
   displayedColumnsGroupShare = ['no', 'group_name' , 'create_by'];
   dataSourceGroup: MatTableDataSource<GroupData>;
   dataSourceGroupShare: MatTableDataSource<GroupData>;
   selectionGroup = new SelectionModel<GroupData>(true, []);
   selectionGroupShare = new SelectionModel<GroupData>(true, []);
   groups: GroupData[] = [];
   groupsShare: GroupData[] = [];
   filterGroupValue: any;
   filterGroupValueShare: any;
   pageSize = 50;
   pageSizeShare = 50;
   searching: any;
   searchingShare: any;
   searchFocused: boolean;
   searchFocusedShare: boolean;
   preventBlur: boolean;
   preventBlurShare: boolean;
   searchResult: any[];
   searchResultShare: any[];
   searchvalue: any;
   searchvalueShare: any;
   private timer: any;

   @ViewChild('txtContactId') public txtContId: MatInput;
   @ViewChild('fullName') public txtFullName;
   @ViewChild('groupName') public txtGroupName;
   @ViewChild('email') public txtEmail: MatInput;
   @ViewChild('btnDel', {static: true}) public buttonDel: MatButton;
   @ViewChild(PaginatorComponent, {static: true}) paginator: PaginatorComponent;
   @ViewChild(PaginatorComponent, {static: true}) paginatorShare: PaginatorComponent;
   @ViewChild('sortMe') sort: MatSort;
   @ViewChild('sortShare') sortShare: MatSort;
   @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;

   @ViewChild(MatAutocompleteTrigger)
   private trigger: MatAutocompleteTrigger;

   private groupDialog: MatDialogRef<NewGroupComponent>;
   private share: MatDialogRef<ShareComponent>;

   constructor(public service: IdexService,
               public toast: Toast,
               public dialog: MatDialog,
               private translate: TranslateService) {
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.clickActive = false;
         this.contactType = 'C';
         this.buttonDel.disabled = true;

         this.getGroupList();
         this.getGroupListShare();
      }, 0);
   }

   highlightGroup(row) {
      if (!this.clickActive) {
         this.groupDialog = this.dialog.open(NewGroupComponent, {
            disableClose: true,
            data: this,
            width: '450px'

         });
         this.groupDialog.componentInstance.isAddGroup = false;
         this.groupDialog.componentInstance.groupIdvalue = row.groupId;
         this.groupDialog.componentInstance.groupNamevalue = row.groupName;
         this.groupDialog.componentInstance.groupContvalue = '';

         this.service.getContactInGroup(row.groupId)
            .subscribe((data: any) => {
               this.groupDialog.componentInstance.members = data;
            }, error => {
               this.errorMessage = error;
            });
         this.groupDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getGroupList();
               this.getGroupListShare();
            }
         });
         this.selectedRowIndexGroup = row.no;

      }
      this.clickActive = false;
   }

   highlightGroupShare(row) {
      if (!this.clickActive) {
         this.groupDialog = this.dialog.open(NewGroupComponent, {
            disableClose: true,
            data: this,
            width: '450px'

         });
         this.groupDialog.componentInstance.viewMode = true;
         this.groupDialog.componentInstance.isAddGroup = false;
         this.groupDialog.componentInstance.groupIdvalue = row.groupId;
         this.groupDialog.componentInstance.groupNamevalue = row.groupName;
         this.groupDialog.componentInstance.groupContvalue = null;

         this.service.getContactInGroup(row.groupId)
            .subscribe((data: any) => {
               this.groupDialog.componentInstance.members = data;
            }, error => {
               this.errorMessage = error;
            });
         this.groupDialog.afterClosed().subscribe(result => {
            if (result) {
               this.getGroupList();
               this.getGroupListShare();
            }
         });
         this.selectedRowIndexGroup = row.no;

      }
      this.clickActive = false;
   }

   LoadGroupTabs(event) {
      const indexSelected = event.index;
      if (indexSelected === 0) {
         this.contactType = 'C';
      } else if (indexSelected === 1) {
         this.contactType = 'G';
      }
      setTimeout(() => {
         if (this.selectTabIndex === 0) {
            this.searching = '';
            this.filterGroupValue = '';
            this.getGroupList();
         }
         if (this.selectTabIndex === 1) {
            this.searchingShare = '';
            this.filterGroupValueShare = '';
            this.getGroupListShare();
         }
      }, 100);
      this.selectionGroup.clear();
      this.selectionGroupShare.clear();
      this.buttonDel.disabled = true;
   }

   getGroupList() {
      this.loader.show();

      merge(this.paginator.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResults = true;
               if (this.paginator.size !== undefined) {
                  this.pageSize = this.paginator.size;
               }

               if (this.filterGroupValue === undefined) {
                  this.filterGroupValue = '';
               }

               let sort = 'group_name';
               let order = 'asc';
               if (this.sort) {
                  sort = this.sort.active;
                  order = this.sort.direction;
               }

               return this.service.getGroupAll(
                  this.pageSize, this.paginator.page, sort, order, encodeURIComponent(this.filterGroupValue), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResults = false;
               this.isRateLimitReached = false;
               this.selectedRowIndexGroup = -1;
               this.selectionGroup.clear();
               this.buttonDel.disabled = true;
               this.resultsLength = data.totalCount;
               this.groups = data.items;
               this.dataSourceGroup = new MatTableDataSource(this.groups);
               if (this.paginator.page !== data.pageIndex) {
                  this.paginator.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResults = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReached = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.dataSourceGroup.data = data);
   }

   getGroupListShare() {
      this.loader.show();

      merge(this.paginatorShare.page)
         .pipe(
            startWith({}),
            switchMap(() => {
               this.isLoadingResultsShare = true;
               if (this.paginatorShare.size !== undefined) {
                  this.pageSizeShare = this.paginatorShare.size;
               }

               if (this.filterGroupValueShare === undefined) {
                  this.filterGroupValueShare = '';
               }

               let sort = 'group_name';
               let order = 'asc';
               if (this.sortShare) {
                  sort = this.sortShare.active;
                  order = this.sortShare.direction;
               }

               return this.service.getGroupAllShare(
                  this.pageSizeShare, this.paginatorShare.page, sort, order, encodeURIComponent(this.filterGroupValueShare), 'f');
            }),
            map(data => {
               // Flip flag to show that loading has finished.
               this.isLoadingResultsShare = false;
               this.isRateLimitReachedShare = false;
               this.selectedRowIndexGroupShare = -1;
               this.selectionGroupShare.clear();
               this.buttonDel.disabled = true;
               this.resultsLengthShare = data.totalCount;
               this.groupsShare = data.items;
               if (this.groupsShare.length !== 0) {
                  this.showTabShare = true;
               }
               this.dataSourceGroupShare = new MatTableDataSource(this.groupsShare);
               if (this.paginatorShare.page !== data.pageIndex) {
                  this.paginatorShare.page = data.pageIndex;
               }

               this.loader.hide();
               return data.items;
            }),
            catchError(() => {
               this.isLoadingResultsShare = false;
               // Catch if the GitHub API has reached its rate limit. Return empty data.
               this.isRateLimitReachedShare = true;
               this.loader.hide();
               return observableOf([]);
            })
         ).subscribe(data => this.dataSourceGroupShare.data = data);
   }

   onSearch(input: any, filterValue: string) {
      this.searchFocused = false;
      this.searchvalue = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterGroupValue = filterValue;
         this.getGroupList();
         input.blur();
      }
   }

   onSearchShare(input: any, filterValue: string) {
      this.searchFocusedShare = false;
      this.searchvalueShare = filterValue;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const value = filterValue.trim();
      if (/[<|>\\\/:?*"^{}%\[\]]/g.test(value)) {
         this.translate.get('alert.create_folder_errors_full').subscribe(s => {
            this.toast.error(s);
         });
      } else {
         filterValue = filterValue.trim(); // Remove whitespace
         filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
         this.filterGroupValueShare = filterValue;
         this.getGroupListShare();
         input.blur();
      }
   }

   onSearchChange(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocused = true;
      }

      this.searchResult = null;
      this.searchChange(input);
   }

   onSearchChangeShare(input: any, e: any) {
      if (e.keyCode !== 13) {
         this.searchFocusedShare = true;
      }

      this.searchResultShare = null;
      this.searchChangeShare(input);
   }

   onSearchBlur() {
      setTimeout(() => {
         if (!this.preventBlur) {
            this.searchFocused = false;
         }
      }, 300);
   }

   onSearchBlurShare() {
      setTimeout(() => {
         if (!this.preventBlurShare) {
            this.searchFocusedShare = false;
         }
      }, 300);
   }

   onSearchFocus(input: any) {
      this.searchFocused = true;
      this.searchChange(input);
   }

   onSearchFocusShare(input: any) {
      this.searchFocusedShare = true;
      this.searchChangeShare(input);
   }

   searchChange(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getGroupAll(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResult = data;
                  }
               });
      }, 300);
   }

   searchChangeShare(input) {
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const kw = encodeURIComponent(input.value.trim());
      if (kw.length === 0) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.service.getGroupAllShare(0, 0, '',
            '', kw, 't')
            .subscribe(
               data => {
                  if (this.timer == null) {
                     this.searchResultShare = data;
                  }
               });
      }, 300);
   }

   activeGroup(id: any, groupName: any, active: any , row: any) {
      this.clickActive = true;
      const gId = id.innerHTML;
      const gName = groupName.innerHTML;
      const activeFlg = active.checked;
      if (activeFlg === false) {
         this.service.activeGroup(gId, gName)
            .subscribe((response) => {
               this.toast.success(response);
               this.getGroupList();
            });
      } else {
         this.service.inactiveGroup(gId, gName)
            .subscribe((response) => {
               this.toast.warn(response);
               if (row.shareId !== 0) {
                  this.service.unshare(row.groupId, 'GP')
                     .subscribe(
                        () => {
                           this.getGroupList();
                        },
                        error => {
                           this.errorMessage = error;
                        });
               } else {
                  this.getGroupList();
               }
            });
      }
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelectedGroup() {
      const numSelected = this.selectionGroup.selected.length;
      const numRows = this.dataSourceGroup.data.length;
      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return numSelected === numRows;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggleGroup() {
      if (this.isAllSelectedGroup()) {
         this.selectionGroup.clear();
         this.buttonDel.disabled = true;
      } else {
         this.dataSourceGroup.data.forEach(row => this.selectionGroup.select(row));
         this.buttonDel.disabled = false;
      }
   }

   disableButtonGroup(row: any) {
      const numSelected = this.selectionGroup.selected.length;
      if (numSelected > 0) {
         this.buttonDel.disabled = false;
      } else {
         this.buttonDel.disabled = true;
      }
      return this.selectionGroup.isSelected(row);
   }

   openGroupDialog() {
      this.groupDialog = this.dialog.open(NewGroupComponent, {
         disableClose: true,
         data: this,
         width: '450px'
      });
      this.groupDialog.componentInstance.groupIdvalue = '';
      this.groupDialog.componentInstance.groupNamevalue = '';
      this.groupDialog.componentInstance.groupContvalue = '';
      this.groupDialog.componentInstance.members = [];
      this.groupDialog.afterClosed().subscribe(result => {
         if (result) {
            this.getGroupList();
            this.getGroupListShare();
         }
      });
   }

   deleteGroup() {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('contact.group').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const IdList: number[] = [];
            for (let i = 0; i < this.selectionGroup.selected.length; i++) {
               IdList.push(this.selectionGroup.selected[i].groupId);
            }
            this.service.deleteGroup(IdList)
               .subscribe((response) => {
                  this.toast.success(response);
                  this.selectionGroup.clear();
                  this.getGroupList();
                  this.getGroupListShare();
               });
         }
      });
   }

   tabShare(row) {
      if (row.shareId !== 0) {
         this.service.getAllShare(row.shareId)
            .subscribe((data: any) => {
               this.share.componentInstance.shareGroup = data.group;
               this.share.componentInstance.shareUser = data.contact;
               this.share.componentInstance.shareSites = data.sites;
               this.share.componentInstance.membersShare = data.UserShares;
               this.share.componentInstance.groupShare = data.GroupShare;
               this.share.componentInstance.siteShare = data.SiteShares;
            }, error => {
               this.errorMessage = error;
            });
      }
      if (!this.clickActive) {
         this.share = this.dialog.open(ShareComponent, {
            disableClose: true,
            data: this,
            width: '600px'
         });
         this.share.componentInstance.objectId = row.groupId;
         this.share.componentInstance.shareId = row.shareId;
         this.share.componentInstance.objectType = 'GP';
         this.share.componentInstance.groupId = row.groupId;
         this.share.afterClosed().subscribe(result => {
            this.getGroupList();
            this.getGroupListShare();
         });
      }
      this.clickActive = false;
   }
}

export interface GroupInfo {
   items: GroupData[];
   totalCount: number;
   pageIndex: number;
}

export interface GroupData {
   groupId: number;
   no: number;
   groupName: string;
   active: boolean;
   shareId: any;
}
